// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import LastContactDetails, {getDefaultState as getLastContactDefaultState} from './lastcontact-details';
import LawEnforcementDetails, {getDefaultState as getLawEnforcementDefaultState} from './law-enforcement-details';
import StatusChangeProduct, {getDefaultState as getStatusChangeProductDefaultState} from './status-change-product';
import TimestampUser, {getDefaultState as getTimestampUserDefaultState} from './timestamp-user';
import File from './file';
import t from 'tcomb';

const StatusChange = t.struct({
    comments: t.String,
    commentsToDealer: t.String,
    createdBy: TimestampUser,
    createdDate: t.Number,
    damageDesc: t.String,
    damageEventDate: t.maybe(t.Number),
    damageEventDesc: t.String,
    file: t.list(File),
    id: t.Number,
    internalDeereComments: t.String,
    lastContactDetails: LastContactDetails,
    lawEnforcementDetails: LawEnforcementDetails,
    machinePutBack: t.String,
    machineStatusUpdateRequestForm: t.String,
    newStatus: KeyValuePair,
    product: StatusChangeProduct,
    status: t.String,
    territory: t.String
}, {
    name: 'StatusChange',
    strict: true
});

export const getDefaultState = () => new StatusChange({
    comments: '',
    commentsToDealer: '',
    createdBy: getTimestampUserDefaultState(),
    createdDate: 0,
    damageDesc: '',
    damageEventDate: null,
    damageEventDesc: '',
    file: [],
    id: 0,
    internalDeereComments: '',
    lastContactDetails: getLastContactDefaultState(),
    lawEnforcementDetails: getLawEnforcementDefaultState(),
    machinePutBack: 'Y',
    machineStatusUpdateRequestForm: '',
    newStatus: getKeyValuePairDefaultState(),
    product: getStatusChangeProductDefaultState(),
    status: 'NEW',
    territory: ''
});

export default StatusChange;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/status-change.js